const checkInstationSite = (path, host) => {
  if (!path)
    return false;
  try {
    const url = new URL(path);
    return url.host.includes(host || "tvb.com");
  } catch (error) {
    console.error(error);
    return false;
  }
};
const getMainHost = () => {
  const key = `mh_${Math.random()}`;
  const keyR = new RegExp(`(^|;)\\s*${key}=12345`);
  const expiredTime = new Date(0);
  const domain = document.domain;
  const domainList = domain.split(".");
  const urlItems = [];
  urlItems.unshift(domainList.pop());
  while (domainList.length) {
    urlItems.unshift(domainList.pop());
    const mainHost = urlItems.join(".");
    const cookie = `${key}=${12345};domain=.${mainHost}`;
    document.cookie = cookie;
    if (keyR.test(document.cookie)) {
      document.cookie = `${cookie};expires=${expiredTime}`;
      return mainHost;
    }
  }
};
const debounce = (func, time, immediate = false) => {
  let timer = null;
  return (...args) => {
    if (timer)
      clearInterval(timer);
    if (immediate) {
      if (!timer)
        func.apply(void 0, args);
      timer = window.setTimeout(() => {
        timer = null;
      }, time);
    } else {
      timer = window.setTimeout(() => {
        func.apply(void 0, args);
      }, time);
    }
  };
};
const getPublishTimestamp = () => {
  const appPublishTime = window.appPublishTime;
  if (appPublishTime) {
    try {
      return (appPublishTime == null ? void 0 : appPublishTime.length) === 13 ? appPublishTime : new Date(appPublishTime).getTime();
    } catch (error) {
      return new Date().getTime();
    }
  }
  return new Date().getTime();
};

export { checkInstationSite, debounce, getMainHost, getPublishTimestamp };
//# sourceMappingURL=index.mjs.map
